import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { InsurancesContainer } from './insurances.container';

const routes: Routes = [
    {
        path: '',
        pathMatch: 'full',
        component: InsurancesContainer,
        data: {
            title: 'Mijn verzekeringsmap - Mijn verzekeringen - InShared',
            description: 'Het gemak van alles online. Regel uw verzekeringen makkelijk en snel via uw digitale Verzekeringsmap.',
        },
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
    },
];

/** @deprecated - insurances functionality is moved to libs/my-zone/insurances */
@NgModule({
    imports: [
        RouterModule.forChild(routes),
    ],
    exports: [
        RouterModule,
    ],
})
export class InsurancesRoutingModule { }
